import axiosInstance from "../axios-interceptor";
import { AppSettings } from "../constant";

const { MasterData } = AppSettings;

// Department APIs
export const addDepartment = async (departmentName) => {
  const res = await axiosInstance.post(MasterData.addDepartment, null, {
    params: { departmentName },
  });
  return res.data;
};

export const updateDepartment = async (id, departmentName) => {
  const res = await axiosInstance.post(MasterData.updateDepartment, null, {
    params: { id, departmentName },
  });
  return res.data;
};

export const getAllDepartments = async () => {
  const res = await axiosInstance.get(MasterData.getAllDepartment);
  return res.data?.response || [];
};

export const getDepartmentById = async (id) => {
  const res = await axiosInstance.get(MasterData.getDepartmentById + id);
  return res.data?.response || null;
};

// Designation APIs
export const addDesignation = async (designationName) => {
  const res = await axiosInstance.post(MasterData.addDesignation, null, {
    params: { designationName },
  });
  return res.data;
};

export const updateDesignation = async (id, designationName) => {
  const res = await axiosInstance.post(MasterData.updateDesignation, null, {
    params: { id, designationName },
  });
  return res.data;
};

export const getAllDesignations = async () => {
  const res = await axiosInstance.get(MasterData.getAllDesignation);
  return res.data?.response || [];
};

export const getDesignationById = async (id) => {
  const res = await axiosInstance.get(MasterData.getDesignationById + id);
  return res.data?.response || null;
};

// Processor APIs
export const addProcessor = async (brandName) => {
  const res = await axiosInstance.post(MasterData.addProcessor, null, {
    params: { brandName },
  });
  return res.data;
};

export const getValueForProcessor = async (processorType) => {
  const res = await axiosInstance.get(
    AppSettings.URLs.getValueForProcessor + processorType
  );
  return res.data?.response || [];
};

export const getProcessorTypes = async () => {
  const res = await axiosInstance.get(MasterData.getPrcessorType); // uses constant, not hardcoded URL
  return res.data?.response || [];
};

export const updateProcessor = async (id, brandName) => {
  const res = await axiosInstance.post(MasterData.updateProcessor, null, {
    params: { id, brandName },
  });
  return res.data;
};

// Generation APIs
export const addGeneration = async (brandId, generationName) => {
  const res = await axiosInstance.post(MasterData.addGenerations, null, {
    params: { brandId, generationName },
  });
  return res.data;
};

export const updateGeneration = async (id, generationName) => {
  const res = await axiosInstance.post(MasterData.updateGenerations, null, {
    params: { id, generationName },
  });
  return res.data;
};

export const getAllGenerations = async () => {
  const res = await axiosInstance.get(MasterData.getAllGenerations);
  return res.data?.response || [];
};

export const addBrandType = async (brandId,brandTypeName) => {
  const res = await axiosInstance.post(MasterData.addBrandType, null, {
    params: {brandId, brandTypeName },
  });
  return res.data;
};

export const updateBrandType = async (id, brandTypeName) => {
  const res = await axiosInstance.post(MasterData.updateBrandType, null, {
    params: { id, brandTypeName },
  });
  return res.data;
};

export const getAllBrandTypes = async () => {
  const res = await axiosInstance.get(MasterData.getAllBrandTypes);
  return res.data?.response || [];
};

export const addUser = async (payload) => {
  const res = await axiosInstance.post(AppSettings.LoginUser.addUser,payload ,{
  });
  return res.data;
};

export const updateUser = async (payload) => {
  const res = await axiosInstance.post(AppSettings.LoginUser.updateUser, payload, {
  });
  return res.data;
};

export const getAllLoginUsers = async () => {
  const res = await axiosInstance.get(AppSettings.LoginUser.getAllLoginUsers);
  return res.data?.response || [];
};

export const getLoginUserById = async (id) => {
  const res = await axiosInstance.get(AppSettings.LoginUser.getLoginUserById + id);
  return res.data?.response || null;
};

export const getRoles = async () => {
  const res = await axiosInstance.get(AppSettings.LoginUser.getRoles);
  return res.data?.response.roles || [];
};


